import { useState, useCallback, ReactNode } from 'react';
import { TourContext, TourPage } from './tourContextDef';

export const TourProvider = ({ children }: { children: ReactNode }) => {
  const [currentPage, setCurrentPage] = useState<TourPage>(null);

  const isTourActive = currentPage !== null && currentPage !== 'completed';

  const startTour = useCallback(() => {
    setCurrentPage('dashboard');
  }, []);

  const advanceTo = useCallback((page: TourPage) => {
    setCurrentPage(page);
  }, []);

  const endTour = useCallback(() => {
    setCurrentPage(null);
  }, []);

  return (
    <TourContext.Provider value={{ isTourActive, currentPage, startTour, advanceTo, endTour }}>
      {children}
    </TourContext.Provider>
  );
};
